import interceptor from 'rest/interceptor';
import { TokenSession, MissingAuthCookieError } from 'urbnTokenLib';
import {
    AUTH_TOKEN_HEADER,
    URBN_LANGUAGE_HEADER,
    URBN_CURRENCY_HEADER,
    URBN_CHANNEL_HEADER,
    URBN_HEADER_DATA_CENTER_ID,
    URBN_HEADER_GEO_REGION,
    COOKIE_NAME_URBN_LANGUAGE,
    COOKIE_NAME_CURRENCY,
    COOKIE_NAME_CHANNEL
} from '../../constants';
import Cookies from '../../services/cookies';

export const requestInterceptorFunc = (request, config, meta, tokenSessionClass) => {
    const route = _.get(meta, 'arguments.0', {});
    let headers = _.cloneDeep(request.headers) || {};

    if (!headers['Content-Type']) {
        headers['Content-Type'] = 'application/json';
    }

    let tokenSession = route.session;
    if (_.isEmpty(tokenSession)) {
        try {
            tokenSession = tokenSessionClass.fromCookie();
        } catch (err) {
            if (err instanceof MissingAuthCookieError) {
                console.debug(`Cannot get auth token from cookie: ${err}`);
            } else {
                console.error(err);
            }
        }
    }

    headers[AUTH_TOKEN_HEADER] = tokenSession.authToken;

    if (typeof tokenSession._data.dataCenterId !== 'undefined') {
        headers[URBN_HEADER_DATA_CENTER_ID] = tokenSession._data.dataCenterId;
    }

    if (typeof tokenSession._data.geoRegion !== 'undefined') {
        headers[URBN_HEADER_GEO_REGION] = tokenSession._data.geoRegion;
    }

    if (!headers[URBN_LANGUAGE_HEADER]) {
        let language = Cookies.getCookieByName(COOKIE_NAME_URBN_LANGUAGE);

        if (!language) {
            language = 'en-US';
        }

        headers[URBN_LANGUAGE_HEADER] = language;
    }

    if (!headers[URBN_CURRENCY_HEADER]) {
        let currency = Cookies.getCookieByName(COOKIE_NAME_CURRENCY);

        if (!currency) {
            currency = 'USD';
        }

        headers[URBN_CURRENCY_HEADER] = currency;
    }

    if (!headers[URBN_CHANNEL_HEADER]) {
        let channel = Cookies.getCookieByName(COOKIE_NAME_CHANNEL);

        if (!channel) {
            channel = 'web';
        }

        headers[URBN_CHANNEL_HEADER] = channel;
    }

    const allowedHeaders = _.get(route, 'allowedHeaders');

    if (allowedHeaders) {
        // BazaarVoice was not even allowing Content-Type as a header, even though it should be allowed
        // without having to specify it in the Access-Control-Allow-Headers preflight response,
        // so now we remove all headers that aren't specified in allowedHeaders
        const currentHeaderNames = _.keys(headers);
        const disallowedHeaderNames = _.difference(currentHeaderNames, allowedHeaders);
        headers = _.omit(headers, disallowedHeaderNames);
    }

    request.headers = headers;

    return request;
};

/**
 * A15 Default Headers interceptor
 *
 * If the request is missing a Content-Type header, this will add an 'application/json' Content-Type header.
 * If the request is missing an X-Urbn-Auth-Token header, this will attempt to create one from the browser's cookies
 */
const a15DefaultHeaders = interceptor({
    request: (request, config, meta) => {
        return requestInterceptorFunc(request, config, meta, TokenSession);
    }
});

export default a15DefaultHeaders;
